"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatfileClient = void 0;
const Client_1 = require("./api/resources/accounts/client/Client");
const Client_2 = require("./api/resources/agents/client/Client");
const Client_3 = require("./api/resources/apps/client/Client");
const Client_4 = require("./api/resources/assistant/client/Client");
const Client_5 = require("./api/resources/auth/client/Client");
const Client_6 = require("./api/resources/cells/client/Client");
const Client_7 = require("./api/resources/commits/client/Client");
const Client_8 = require("./api/resources/dataRetentionPolicies/client/Client");
const Client_9 = require("./api/resources/documents/client/Client");
const Client_10 = require("./api/resources/entitlements/client/Client");
const Client_11 = require("./api/resources/environments/client/Client");
const Client_12 = require("./api/resources/events/client/Client");
const Client_13 = require("./api/resources/files/client/Client");
const Client_14 = require("./api/resources/foreigndb/client/Client");
const Client_15 = require("./api/resources/guests/client/Client");
const Client_16 = require("./api/resources/jobs/client/Client");
const Client_17 = require("./api/resources/mapping/client/Client");
const Client_18 = require("./api/resources/records/client/Client");
const Client_19 = require("./api/resources/roles/client/Client");
const Client_20 = require("./api/resources/secrets/client/Client");
const Client_21 = require("./api/resources/sheets/client/Client");
const Client_22 = require("./api/resources/snapshots/client/Client");
const Client_23 = require("./api/resources/spaces/client/Client");
const Client_24 = require("./api/resources/users/client/Client");
const Client_25 = require("./api/resources/versions/client/Client");
const Client_26 = require("./api/resources/views/client/Client");
const Client_27 = require("./api/resources/workbooks/client/Client");
class FlatfileClient {
    constructor(_options = {}) {
        this._options = _options;
    }
    get accounts() {
        var _a;
        return ((_a = this._accounts) !== null && _a !== void 0 ? _a : (this._accounts = new Client_1.Accounts(this._options)));
    }
    get agents() {
        var _a;
        return ((_a = this._agents) !== null && _a !== void 0 ? _a : (this._agents = new Client_2.Agents(this._options)));
    }
    get apps() {
        var _a;
        return ((_a = this._apps) !== null && _a !== void 0 ? _a : (this._apps = new Client_3.Apps(this._options)));
    }
    get assistant() {
        var _a;
        return ((_a = this._assistant) !== null && _a !== void 0 ? _a : (this._assistant = new Client_4.Assistant(this._options)));
    }
    get auth() {
        var _a;
        return ((_a = this._auth) !== null && _a !== void 0 ? _a : (this._auth = new Client_5.Auth(this._options)));
    }
    get cells() {
        var _a;
        return ((_a = this._cells) !== null && _a !== void 0 ? _a : (this._cells = new Client_6.Cells(this._options)));
    }
    get commits() {
        var _a;
        return ((_a = this._commits) !== null && _a !== void 0 ? _a : (this._commits = new Client_7.Commits(this._options)));
    }
    get dataRetentionPolicies() {
        var _a;
        return ((_a = this._dataRetentionPolicies) !== null && _a !== void 0 ? _a : (this._dataRetentionPolicies = new Client_8.DataRetentionPolicies(this._options)));
    }
    get documents() {
        var _a;
        return ((_a = this._documents) !== null && _a !== void 0 ? _a : (this._documents = new Client_9.Documents(this._options)));
    }
    get entitlements() {
        var _a;
        return ((_a = this._entitlements) !== null && _a !== void 0 ? _a : (this._entitlements = new Client_10.Entitlements(this._options)));
    }
    get environments() {
        var _a;
        return ((_a = this._environments) !== null && _a !== void 0 ? _a : (this._environments = new Client_11.Environments(this._options)));
    }
    get events() {
        var _a;
        return ((_a = this._events) !== null && _a !== void 0 ? _a : (this._events = new Client_12.Events(this._options)));
    }
    get files() {
        var _a;
        return ((_a = this._files) !== null && _a !== void 0 ? _a : (this._files = new Client_13.Files(this._options)));
    }
    get foreigndb() {
        var _a;
        return ((_a = this._foreigndb) !== null && _a !== void 0 ? _a : (this._foreigndb = new Client_14.Foreigndb(this._options)));
    }
    get guests() {
        var _a;
        return ((_a = this._guests) !== null && _a !== void 0 ? _a : (this._guests = new Client_15.Guests(this._options)));
    }
    get jobs() {
        var _a;
        return ((_a = this._jobs) !== null && _a !== void 0 ? _a : (this._jobs = new Client_16.Jobs(this._options)));
    }
    get mapping() {
        var _a;
        return ((_a = this._mapping) !== null && _a !== void 0 ? _a : (this._mapping = new Client_17.Mapping(this._options)));
    }
    get records() {
        var _a;
        return ((_a = this._records) !== null && _a !== void 0 ? _a : (this._records = new Client_18.Records(this._options)));
    }
    get roles() {
        var _a;
        return ((_a = this._roles) !== null && _a !== void 0 ? _a : (this._roles = new Client_19.Roles(this._options)));
    }
    get secrets() {
        var _a;
        return ((_a = this._secrets) !== null && _a !== void 0 ? _a : (this._secrets = new Client_20.Secrets(this._options)));
    }
    get sheets() {
        var _a;
        return ((_a = this._sheets) !== null && _a !== void 0 ? _a : (this._sheets = new Client_21.Sheets(this._options)));
    }
    get snapshots() {
        var _a;
        return ((_a = this._snapshots) !== null && _a !== void 0 ? _a : (this._snapshots = new Client_22.Snapshots(this._options)));
    }
    get spaces() {
        var _a;
        return ((_a = this._spaces) !== null && _a !== void 0 ? _a : (this._spaces = new Client_23.Spaces(this._options)));
    }
    get users() {
        var _a;
        return ((_a = this._users) !== null && _a !== void 0 ? _a : (this._users = new Client_24.Users(this._options)));
    }
    get versions() {
        var _a;
        return ((_a = this._versions) !== null && _a !== void 0 ? _a : (this._versions = new Client_25.Versions(this._options)));
    }
    get views() {
        var _a;
        return ((_a = this._views) !== null && _a !== void 0 ? _a : (this._views = new Client_26.Views(this._options)));
    }
    get workbooks() {
        var _a;
        return ((_a = this._workbooks) !== null && _a !== void 0 ? _a : (this._workbooks = new Client_27.Workbooks(this._options)));
    }
}
exports.FlatfileClient = FlatfileClient;
